import { QueryFunctionContext } from 'react-query';
import { FILES_PER_ROW, FOLDERS_PER_ROW } from '../../constant/numericParams';
import { tmsHTTPRequest } from '../../services/axios/httpRequest';

export const getIndependentFiles = async ({
  pageParam = 1,
  queryKey,
}: QueryFunctionContext<any[], any>) => {
  return tmsHTTPRequest.get(
    `/v1/files/get-all-in-dashboard?PageNumber=${pageParam}&PageSize=${
      queryKey[2] || FILES_PER_ROW
    }&FileType=${queryKey[1]}`
  );
};

export const getExistingFolder = ({
  pageParam = 1,
  queryKey,
}: QueryFunctionContext<any[], any>) => {
  return tmsHTTPRequest.get(
    `/v1/folders/get-all-in-dashboard?PageNumber=${pageParam}&PageSize=${
      queryKey[2] || FOLDERS_PER_ROW
    }`
  );
};

export const putFileName = (
  id: number | string,
  name?: string,
  folderId?: number | string
) => {
  return tmsHTTPRequest.put(`/v1/files/edit/${id}`, {
    id,
    name,
    folderId,
  });
};
